var MapsSearch = function () {

	var infoWindows = [];

	var stateArray = [
		{ shortName: 'AC', fullName: 'Acre' },
		{ shortName: 'AL', fullName: 'Alagoas' },
		{ shortName: 'AP', fullName: 'Amapá' },
		{ shortName: 'AM', fullName: 'Amazônia' },
		{ shortName: 'BA', fullName: 'Bahia' },
		{ shortName: 'CE', fullName: 'Ceará' },
		{ shortName: 'DF', fullName: 'Brasília' },
		{ shortName: 'ES', fullName: 'Espirito Santo' },
		{ shortName: 'GO', fullName: 'Goiás' },
		{ shortName: 'MA', fullName: 'Maranhão' },
		{ shortName: 'MT', fullName: 'Mato Grosso' },
		{ shortName: 'MS', fullName: 'Mato Grosso do Sul' },
		{ shortName: 'MG', fullName: 'Minas Gerais' },
		{ shortName: 'PA', fullName: 'Pará' },
		{ shortName: 'PB', fullName: 'Paraíba' },
		{ shortName: 'PR', fullName: 'Paraná' },
		{ shortName: 'PE', fullName: 'Piauí' },
		{ shortName: 'PI', fullName: 'Pernambuco' },
		{ shortName: 'RJ', fullName: 'Rio de Janeiro' },
		{ shortName: 'RN', fullName: 'Rio Grande do Norte' },
		{ shortName: 'RS', fullName: 'Rio Grande do Sul' },
		{ shortName: 'RO', fullName: 'Rondônia' },
		{ shortName: 'RR', fullName: 'Roraima' },
		{ shortName: 'SC', fullName: 'Santa Catarina' },
		{ shortName: 'SP', fullName: 'São Paulo' },
		{ shortName: 'SE', fullName: 'Sergipe' },
		{ shortName: 'TO', fullName: 'Tocatins' }
	];

	var searchState = function searchState(place) {

		if (place.address_components) {

			for (var i = 0; i < place.address_components.length; i += 1) {

				for (var j = 0; j < stateArray.length; j += 1) {
	
					if (place.address_components[i].short_name === stateArray[j].shortName) {
						return j;
					}
				}
			}
		}
		else if (place.formatted_address) {

			var addressArray = place.formatted_address.split(',');

			for (var i = 0; i < addressArray.length; i += 1) {

				for (var j = 0; j < stateArray.length; j += 1) {
	
					if (addressArray[i].trim() === stateArray[j].shortName || addressArray[i].trim().toLowerCase() === stateArray[j].fullName.toLowerCase()) {
						return j;
					}
				}
			}

			for (var i = 0; i < addressArray.length; i += 1) {

				for (var j = 0; j < stateArray.length; j += 1) {
	
					if (addressArray[i].indexOf(stateArray[j].shortName) > 0) {
						return j;
					}
				}
			}

			var latlng = place.geometry.location.lat() + "," + place.geometry.location.lng();
			var key = $("[data-component='maps-search']").data("key");
			var returnIndex = -1;

			$.ajax({
				type: "GET",
				url: "https://maps.googleapis.com/maps/api/geocode/json",
				data: { "latlng": latlng, "sensor": true, "key": key },
				dataType: "json",
				async: false,
				success: function (response) {
					
					returnIndex = searchState(response.results[0]);
				},
				error: function (e) {
	
				}
			});

			return returnIndex;
		}

		return -1;
	}

	var clearAllInfoWindows = function clearAllInfoWindows() {

		infoWindows.forEach(function (infoWindow) {
			infoWindow.close();
		});
	}

	var attachDescriptionEventVar = function attachDescriptionEvent(marker, secretMessage) {

		var infoWindow = new google.maps.InfoWindow({
			content: secretMessage
		});

		infoWindows.push(infoWindow);

		marker.addListener('click', function () {

			clearAllInfoWindows();
			infoWindow.open(marker.get('map'), marker)
		});
	}

	var getEventInfoForPin = function (event) {

		var html = "";

		html += '<div class="container row" style="col-md-8">';
		html += '<div class="row">';
		html += '<div>';
		html += '<h3 style="position: relative; text-align: justify;">' + event.Title + '</h3>';
		html += '<p style="font-size:10pt">' + event.Description + '</p>';

		if (event.ButtonText)
			html += '<p><a class="btn btn-primary btn-lg " href="' + event.ButtonURL + '" role="button" style=" margin-top: 30px">' + event.ButtonText + '</a></p>';

		html += '</div>';
		html += '</div>';
		html += '</div>';

		return html;
	}

	var getEventInfoForCard = function (event) {

		var html = "";

		html += '<div class="col-md-4 col-sm-6 col-xs-12">';
		html += '<div data-component="card-item" class="find-event">';
		html += '<div class="content content-default">';
		html += '<div class="infos">';
		html += '<h3 class="title">' + event.Title + '</h3>';
		html += '<div class="description">';
		html += event.Description;
		html += '</div>';
		html += '<a href="' + event.ButtonURL + '" class="btn-more">' + event.ButtonText + '</a>';
		html += '</div>';
		html += '</div>';
		html += '</div>';
		html += '</div>';

		return html;
	}

	var getDistance = function (coord1, coord2) {

		var R = 6371;
		var dLat = (coord2.lat - coord1.lat) * (Math.PI / 180);
		var dLon = (coord2.lng - coord1.lng) * (Math.PI / 180);
		var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(coord1.lat * (Math.PI / 180)) * Math.cos(coord2.lat * (Math.PI / 180)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
		var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		var d = R * c

		return d;
	}

	var loadCities = function (componentID) {

		$.ajax({
			type: "POST",
			url: "/umbraco/surface/Maps/GetAllEvents",
			data: JSON.stringify({ "ComponentID": componentID }),
			dataType: "json",
			async: false,
			contentType: "application/json; charset=utf-8",
			success: function (response) {

				cities = response;
			},
			error: function (e) {

			}
		});

		return cities;
	}

	var appendHtml = function (map, places, bounds, markers, cities) {

		var isUndefined = false;
		var searchCoord;

		if (typeof (places[0]) === 'undefined') {

			searchCoord = { lat: -11.731317, lng: -53.387155 };
			map.setCenter(searchCoord);
			map.setZoom(3);
			isUndefined = true;
		}
		else {

			searchCoord = { lat: Number(places[0].geometry.location.lat()), lng: Number(places[0].geometry.location.lng()) };
		}

		var searchRadius = 0;
		var currentZoom = map.getZoom();

		var northEastCoord = { lat: map.getBounds().getNorthEast().lat(), lng: map.getBounds().getNorthEast().lng() };
		var southWestCoord = { lat: map.getBounds().getSouthWest().lat(), lng: map.getBounds().getSouthWest().lng() };
		var northWestCoord = { lat: northEastCoord.lat, lng: southWestCoord.lng };
		var northCoord = { lat: ((northEastCoord.lat + northWestCoord.lat) / 2), lng: ((northEastCoord.lng + northWestCoord.lng) / 2) }

		if (currentZoom >= 13) {

			searchRadius = getDistance(searchCoord, northEastCoord);
		}
		else {

			searchRadius = getDistance(searchCoord, northCoord);
		}

		var StandardRadius = $("[data-component='maps-search']").data("radius");$("[data-component='maps-search']").data("radius");

		if (searchRadius < StandardRadius) {
			searchRadius = StandardRadius;
		}

		map.fitBounds(bounds);

		$(".eventsAppend").empty();

		var stateIndex = searchState(places[0]);

		var eventHTML = createEventDescriptions(map, cities, stateArray[stateIndex], searchCoord, searchRadius, isUndefined, markers, bounds);

		if (eventHTML === "") {

			if (stateIndex === -1) {

				//nothing found
				$(".legend-result").text("Nenhum resultado encontrado");
			}
			else {

				eventHTML = createEventDescriptionsByState(map, cities, stateArray[stateIndex], isUndefined, markers, bounds);
			}
		}

		$(".eventsAppend").append(eventHTML);

		$(".search-legend").text($("[data-component='maps-search']").data("message") + ' perto de "' + places[0].formatted_address + '"');
	}

	var createEventDescriptions = function (map, cities, state, searchCoord, searchRadius, isUndefined, markers, bounds) {

		var html = "", lastHTML = "";
		var counter = 0;

		for (var i = 0; i < cities.length; i++) {

			var hasEvents = false;
			var cityState = cities[i].State;
			html = "";

			for (var j = 0; j < cities[i].EventList.length; j++) {

				var event = cities[i].EventList[j];
				var eventCoord = { lat: Number(event.Latitude), lng: Number(event.Longitude) };

				if (getDistance(eventCoord, searchCoord) < searchRadius && !isUndefined && cityState == state.shortName) {

					counter++;
					hasEvents = true;

					html += getEventInfoForCard(event);

					markers.push(new google.maps.Marker({
						position: { lat: Number(event.Latitude), lng: Number(event.Longitude) },
						map: map,
						title: event.Title
					}));

					attachDescriptionEventVar(markers[markers.length - 1], getEventInfoForPin(event));

					markers[markers.length - 1].setMap(map);

					bounds.extend(new google.maps.LatLng(Number(event.Latitude), Number(event.Longitude)));
				}
			}

			map.fitBounds(bounds);

			if (hasEvents) {

				html = '<h4 class="title-result">' + cities[i].CityName + '</h4> <div class="row">' + html + '</div>';
			}

			lastHTML += html;
		}

		//no events, return null
		if (counter == 0) {

			return "";
		}
		else {

			$(".legend-result").text(counter + " " + (counter > 1 ? " resultados encontrados" : " resultado encontrado"));
			return lastHTML;
		}
	}

	var createEventDescriptionsByState = function(map, cities, state, isUndefined, markers, bounds) {

		var html = "", lastHTML = "";
		var counter = 0;

		for (var i = 0; i < cities.length; i++) {

			var hasEvents = false;
			var cityState = cities[i].State;
			html = "";

			for (var j = 0; j < cities[i].EventList.length; j++) {

				var event = cities[i].EventList[j];

				if (cityState == state.shortName && !isUndefined) {

					counter++;
					hasEvents = true;

					html += getEventInfoForCard(event);

					markers.push(new google.maps.Marker({
						position: { lat: Number(event.Latitude), lng: Number(event.Longitude) },
						map: map,
						title: event.Title
					}));

					attachDescriptionEventVar(markers[markers.length - 1], getEventInfoForPin(event));

					markers[markers.length - 1].setMap(map);

					bounds.extend(new google.maps.LatLng(Number(event.Latitude), Number(event.Longitude)));
				}
			}

			map.fitBounds(bounds);

			if (hasEvents) {

				html = '<h4 class="title-result">' + cities[i].CityName + '</h4> <div class="row">' + html + '</div>';
			}

			lastHTML += html;
		}

		//no events, return null
		if (counter == 0) {

			$(".legend-result").text("Nenhum resultado encontrado");
			return "";
		}
		else {

			$(".legend-result").text(counter + " " + (counter > 1 ? " resultados encontrados" : " resultado encontrado"));
			return lastHTML;
		}
	}

	this.mapsSearch = function () {

		var map = new google.maps.Map(document.getElementById('map'), {
			center: { lat: -12.584105, lng: -50.485991 },
			zoom: 3.5,
			mapTypeId: 'roadmap'
		});

		map.addListener('bounds_changed', function () {
			searchBox.setBounds(map.getBounds());
		});

		var input = document.getElementById('pac-input');
		var searchBox = new google.maps.places.SearchBox(input);
		var cities = loadCities($("[data-component='maps-search']").data("id"));
		var markers = [];

		searchBox.addListener('places_changed', function () {

			var places = searchBox.getPlaces();

			if (places.length == 0) {
				return;
			}

			markers.forEach(function (marker) {
				marker.setMap(null);
			});

			markers = [];

			var bounds = new google.maps.LatLngBounds();

			places.forEach(function (place) {

				if (place.geometry.viewport) {

					bounds.union(place.geometry.viewport);
				}
				else {

					bounds.extend(place.geometry.location);
				}
			});

			map.fitBounds(bounds);

			appendHtml(map, places, bounds, markers, cities);
		});
	}

	this.buttonSend = function () {

		$("[data-component='inline-search'] form").submit(function (e) {
			e.preventDefault();
		});

		document.getElementById('trigger-search').onclick = function () {
			var input = document.getElementById('pac-input');

			input.focus();
			google.maps.event.trigger(input, 'keydown', { keyCode: 13 });
		};
	}

	this.init = function () {

		this.mapsSearch();

		this.buttonSend();
	}

	return this.init();
}